var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BDA6B7B8-01A0-4D67-959A-780853797D59") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component/Alert/Resend-Email-Verification",
    transform: "translate(-23.000000, -29.000000)",
    fill: "#C0C6D4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(11.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.875,0 L3.125,0 C1.39987512,0.00187893631 0.00184538388,1.42532739 0,3.18181818 L0,16.8181818 C0.00184538388,18.5746726 1.39987512,19.9981211 3.125,20 L21.875,20 C23.6001249,19.9981211 24.9981546,18.5746726 25,16.8181818 L25,3.18181818 C24.9981546,1.42532739 23.6001249,0.00187893631 21.875,0 Z M21.0837054,5.26306818 L13.0479911,11.6267045 C12.7256373,11.8818555 12.2743627,11.8818555 11.9520089,11.6267045 L3.91629464,5.26306818 C3.65934892,5.06550103 3.52677943,4.74237793 3.56934564,4.4174193 C3.61191186,4.09246067 3.8230196,3.81600763 4.12183796,3.69391113 C4.42065631,3.57181463 4.76089368,3.6229893 5.01227679,3.82784091 L12.5,9.75738636 L19.9877232,3.82784091 C20.3773223,3.52827579 20.9309942,3.60286991 21.2306636,3.99529756 C21.530333,4.38772522 21.46487,4.95245786 21.0837054,5.26306818 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailFill);
export default __webpack_public_path__ + "static/media/mail-fill.c5a07eb469235812cdc70e13f395b44b.svg";
export { ForwardRef as ReactComponent };